import React, { useEffect } from 'react';
import { Link, useNavigate } from "react-router-dom";
import { Button } from 'antd';
import GhatikLogo2 from "../../Images/GhatikLogo2.png";


const DirectFinanceScheme = () => {
  useEffect(() => {
    // Scroll to the top of the page when this component is mounted
    window.scrollTo(0, 0);
  }, []);
  const navigate = useNavigate();

  return (
    <div style={{ maxWidth: "800px", margin: "0 auto", padding: "20px", background: "#fff", fontFamily: "Arial, sans-serif" }}>
     <div style={{ display: "flex", alignItems: "center", justifyContent: "left", marginBottom: "20px" }}>
        <img 
          src={GhatikLogo2} 
          alt="Logo" 
          style={{ width: "50px", height: "50px", objectFit: "contain", marginRight: "10px" }} 
        />
        <h1 style={{ fontSize: "24px", fontWeight: "bold", color: "red", margin: 0 }}>
          DIRECT FINANCE SCHEME
        </h1>
      </div>

      <p style={{ fontSize: "14px", color: "#555", textAlign: "left",marginBottom: "10px" }}>
        Procedures to be followed while implementing direct finance scheme
      </p>
      <p style={{ fontSize: "12px", color: "#777", textAlign: "left",marginBottom: "20px" }}>
        * Various schemes are implemented by the Mahatma Phule Backward Classes Development Corporation. A special component scheme is being implemented in this and under this scheme Loans up to Rs. 1,00,000/- are sanctioned by the Corporation. The Corporation's participation in this is Rs. 85,000/- and the grant is Rs. 10,000/- (with limit). Also the participation of the applicant is Rs. 5,000/-. The loan is to be repaid in 3 years at the same monthly installment. The interest rate on this loan is 4% per cent.
      </p>
      <p style={{ fontSize: "12px", color: "#777", textAlign: "left",marginBottom: "20px" }}>
        * People from backward classes should be financially empowered and maximum number of people should be able to benefit. Also, to avoid difficulties in lending through banks and delays in loan disbursement, the loan limit of the direct scheme is Rs. 25,000/- to Rs. 1,00,000/- has been sanctioned as per Government Resolution No. MPC-201стве, dated 21st December 2018.
      </p>
      <p style={{ fontSize: "12px", color: "#777",textAlign: "left", marginBottom: "20px" }}>
        Under this scheme, loan scheme is implemented directly from the share capital received by Mahatma Phule Corporation. The format of the scheme is as follows.
      </p>
      <ul style={{ fontSize: "12px", color: "#555", textAlign: "left",marginBottom: "20px", paddingLeft: "20px" }}>
      <ul style={{ listStyleType: "none", paddingLeft: 0 }}>
          <li style={{ display: "flex", alignItems: "center", marginBottom: "8px" }}>
            <span style={{ color: "grey", marginRight: "8px" }}>✓</span>
            Project limit is Rs. Up to Rs. 1,00,000/-
          </li>
          <li style={{ display: "flex", alignItems: "center", marginBottom: "8px" }}>
            <span style={{ color: "grey", marginRight: "8px" }}>✓</span>
            Corporation's participation is Rs. 85,000/- and the grant is Rs. 10,000/- (with limit).
          </li>
          <li style={{ display: "flex", alignItems: "center", marginBottom: "8px" }}>
            <span style={{ color: "grey", marginRight: "8px" }}>✓</span>
            Applicant's participation is Rs. 5,000/-
          </li>
          <li style={{ display: "flex", alignItems: "center", marginBottom: "8px" }}>
            <span style={{ color: "grey", marginRight: "8px" }}>✓</span>
            The loan is to be repaid within 3 years (36 months) in equal monthly installments.
          </li>
          <li style={{ display: "flex", alignItems: "center", marginBottom: "8px" }}>
            <span style={{ color: "grey", marginRight: "8px" }}>✓</span>
            There is 4% interest rate on this loan.
          </li>
        </ul>

      </ul>
      <p style={{ fontSize: "14px", color: "#333",textAlign: "left", fontWeight: "bold", marginBottom: "10px" }}>
        A) Documents required for loan approval.
      </p>
      <ol style={{ fontSize: "12px", color: "#555",textAlign: "left", marginBottom: "20px", paddingLeft: "20px" }}>
        <li>1.Cast Certificate.</li>
        <li>2.Income Certificate.</li>
        <li>3.Residential Proof (Ration Card, Aadhar Card, Voters Card, PAN Card, Electricity Bill etc).</li>
        <li>4.Documents related to the business such as the price list of goods.</li>
      </ol>
      <p style={{ fontSize: "14px", color: "#333", textAlign: "left",fontWeight: "bold", marginBottom: "10px" }}>
        B) After fulfilling the required documents, the following action is taken by the concerned district office.
      </p>
      <ol style={{ fontSize: "12px", color: "#555",textAlign: "left", marginBottom: "20px", paddingLeft: "20px" }}>
        <li>1.The residence of the applicant as well as the place of business is verified.</li>
        <li>2.Approval and funding are sought from the Regional Manager.</li>
        <li>3.The first installment (75%) is paid by the district office excluding the beneficiary's contribution in the respective loan case and the second installment (25%) is paid after the commencement of the actual business as per the Inspection opinion conducted by the Regional Manager.</li>
      </ol>
      <div style={{ textAlign: "left",  }}>
        <Button
          type="primary"
          style={{ background: "#1e40af", borderColor: "#1e40af",  fontSize: "14px" }}
          onClick={() => navigate("/apply")}
        >
          Apply
        </Button>
      </div>
    </div>
  );
};

export default DirectFinanceScheme;